import Controller from "./mainFooter.controller";
import template from "./mainFooter.html";

const mainFooter = {
  template,
  controller: Controller,
  bindings: {
    activityParams: "<",
    activityTitle: "@",
  },
};

export default mainFooter;



// WEBPACK FOOTER //
// ./src/components/mainFooter/mainFooter.component.js